import React, { Component } from "react";
import Layout from "./Layout";
import UsersViews from "../views/Users";
import { Redirect } from "react-router-dom";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      table: {
        data: [],
        loading: true,
        totalRows: 0,
        perPage: 10
      }
    };
  }

  componentDidMount() {
    const get_token = localStorage.getItem("token");

    const requestOptions = {
      method: "POST",
      mode: "cors",
      body: JSON.stringify({ get_token: get_token })
    };

    fetch(`./wp-json/asd/users/data`, requestOptions)
      .then(response => response.json())
      .then(userData => {
        if (
          "jwt_auth_invalid_token" === userData.code ||
          "jwt_auth_bad_iss" === userData.code
        ) {
          localStorage.removeItem("token");
          window.location.href = "/asd-login";
        } else if ("jwt_auth_bad_request" === userData.code) {
          if (userData.message) {
            alert(userData.message);
          }
        } else if (userData.data != null) {
          this.setState({
            table: {
              data: userData.data,
              loading: false,
              totalRows: userData.total
            }
          });
        }
      });
  }

  render() {
    const isAlreadyAuthenticated = localStorage.getItem("token");
        const handleInpersonate = (event, newValue) => {
        if( event.currentTarget.attributes.getNamedItem('data-impersonation').value === "true"){
            localStorage.setItem('inpersonate', true);
        }else{
            localStorage.setItem('inpersonate', false);
        }
        const get_token = localStorage.getItem("token");
        const user_id = event.currentTarget.id
        const requestOptions = {
          method: "POST",
          mode: "cors",
          body: JSON.stringify({ get_token: get_token,user_id:user_id })
        };
        if(event.currentTarget.id!=''){

            fetch(`./wp-json/asd/users/inpersonate`, requestOptions)
              .then(response => response.json())
              .then(userData => {
                console.log(userData);
                if (
                  "jwt_auth_invalid_token" === userData.code ||
                  "jwt_auth_bad_iss" === userData.code
                ) {
                  localStorage.removeItem("token");
                  window.location.href = "/asd-login";
                } else if ("jwt_auth_bad_request" === userData.code) {
                  if (userData.message) {
                    alert(userData.message);
                  }
                } else if (userData != null) {
                  if (userData.token != null) {
                    localStorage.setItem('token', userData.token);
                    localStorage.setItem('inpersonate_user', userData.inpersonate_user);
                    localStorage.setItem('inpersonate_id', user_id);
                    window.location.href = './';
                  }
                }
              });
            }
    };


      const handleAddUser = () => {
          localStorage.removeItem("inpersonate_id");
          window.location.href = './create-edit';
      };
        const handleDeleteUser = (event, newValue) => {
            const user_id = event.currentTarget.id;
            const get_token = localStorage.getItem("token");
            const userId = localStorage.getItem("userId");
            confirmAlert({
                title: 'Confirm to delete',
                message: 'Are you sure want to delete User?',
                buttons: [
                    {
                        label: 'Yes',
                        onClick: () => {
                            const requestOptions = {
                                method: "DELETE",
                                mode: "cors",
                                headers : {
                                    'Authorization': 'Bearer '+get_token,
                                },
                            };
                            if( user_id !== ''){
                                fetch(`./wp-json/wp/v2/users/`+user_id+'?reassign='+userId+'&force=true', requestOptions)
                                    .then(response => response.json())
                                    .then(userData => {
                                        window.location.href = './users';
                                    });
                            }
                        }
                    },
                    {
                        label: 'No',
                        onClick: () => {
                            return false;
                        }
                    }
                ]
            });
      };
      const handleEditUser = (event, newValue) => {
              const user_id = event.currentTarget.id;
              const get_token = localStorage.getItem("token");
              const userId = localStorage.getItem("userId");
              const requestOptions = {
                  method: "DELETE",
                  mode: "cors",
                  headers : {
                      'Authorization': 'Bearer '+get_token,
                  },
              };
              if( user_id !== ''){
                  localStorage.setItem('inpersonate_id', user_id);
                  window.location.href = './create-edit';

              }

      };

    return (
      <Layout>
        {isAlreadyAuthenticated ? (
          <UsersViews
            userData={this.state.table.data}
            userLoading={this.state.table.loading}
            userRows={this.state.table.totalRows}
            handleInpersonate={handleInpersonate}
            handleDeleteUser={handleDeleteUser}
            handleEditUser={handleEditUser}
            handleAddUser={handleAddUser}
          />
        ) : (
          <Redirect to={{ pathname: "/asd-login" }} />
        )}
      </Layout>
    );
  }
}

export default Users;
